import React from 'react';
import { MapPin, Phone, Mail, Clock, MessageCircle } from 'lucide-react';
import { clinicInfo } from '../mockData';

const Contact = () => {
  const handleWhatsApp = () => {
    const message = encodeURIComponent('Hi, I would like to book an appointment at Dr. Kotecha\'s Dental Clinic.');
    window.open(`https://wa.me/91${clinicInfo.phone}?text=${message}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-white pt-24">
      {/* Hero Section */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="heading-1 text-white mb-6">CONTACT US</h1>
            <p className="body-large text-gray-300">
              Get in touch with us to schedule your appointment or ask any questions
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            {/* Contact Cards */}
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div className="bg-gray-900 p-8 rounded-lg text-center">
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
                  <Phone className="w-8 h-8 text-gray-900" />
                </div>
                <h3 className="heading-4 text-white mb-4">Call Us</h3>
                <p className="body-small text-gray-400 mb-6">
                  Speak directly with our team to book your appointment
                </p>
                <a
                  href={`tel:${clinicInfo.phone}`}
                  className="btn-primary w-full"
                >
                  Call {clinicInfo.phone}
                </a>
              </div>

              <div className="bg-gray-900 p-8 rounded-lg text-center">
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
                  <MessageCircle className="w-8 h-8 text-gray-900" />
                </div>
                <h3 className="heading-4 text-white mb-4">WhatsApp</h3>
                <p className="body-small text-gray-400 mb-6">
                  Message us on WhatsApp for quick responses
                </p>
                <button
                  onClick={handleWhatsApp}
                  className="btn-primary w-full"
                >
                  Message on WhatsApp
                </button>
              </div>
            </div>

            {/* Contact Information */}
            <div className="bg-black p-8 rounded-lg">
              <h2 className="heading-3 text-white mb-8 text-center">CLINIC INFORMATION</h2>
              
              <div className="grid md:grid-cols-2 gap-8">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-gray-900" />
                  </div>
                  <div>
                    <h3 className="heading-5 text-white mb-2">Address</h3>
                    <p className="body-small text-gray-300">{clinicInfo.address}</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center flex-shrink-0">
                    <Mail className="w-6 h-6 text-gray-900" />
                  </div>
                  <div>
                    <h3 className="heading-5 text-white mb-2">Email</h3>
                    <a 
                      href={`mailto:${clinicInfo.email}`}
                      className="body-small text-gray-300 hover:text-white transition-colors"
                    >
                      {clinicInfo.email}
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center flex-shrink-0">
                    <Phone className="w-6 h-6 text-gray-900" />
                  </div>
                  <div>
                    <h3 className="heading-5 text-white mb-2">Phone</h3>
                    <a 
                      href={`tel:${clinicInfo.phone}`}
                      className="body-small text-gray-300 hover:text-white transition-colors"
                    >
                      {clinicInfo.phone}
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center flex-shrink-0">
                    <Clock className="w-6 h-6 text-gray-900" />
                  </div>
                  <div>
                    <h3 className="heading-5 text-white mb-2">Working Hours</h3>
                    <p className="body-small text-gray-300">{clinicInfo.workingHours.weekdays}</p>
                    <p className="body-small text-gray-300 mt-1">{clinicInfo.workingHours.weekend}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-20 bg-gray-900">
        <div className="container mx-auto px-6">
          <h2 className="heading-2 text-white text-center mb-12">FIND US</h2>
          <div className="max-w-5xl mx-auto">
            <div className="rounded-lg overflow-hidden mb-6">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3767.7894!2d72.8377!3d19.2045!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDEyJzE2LjIiTiA3MsKwNTAnMTUuNyJF!5e0!3m2!1sen!2sin!4v1234567890"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Dr. Kotecha's Dental Clinic Location"
              ></iframe>
            </div>
            <div className="text-center">
              <a
                href="https://maps.google.com/?q=Shop+no.+11+First+floor+Rodium+X+one+67+Shankar+Ln+Kandivali+West+Mumbai+Maharashtra+400067"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary inline-flex items-center"
              >
                <MapPin size={20} className="mr-2" />
                Get Directions on Google Maps
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
